// React and Router
import React, { useState } from 'react'
import { useNavigate, NavLink } from 'react-router-dom'

// Form and Validation
import { Field, FormikProvider, useFormik } from 'formik'
import * as Yup from 'yup'

// Components
import Input from '../../../components/common/CustomInput'

// Utils
import { setToken } from '../../../utils/cookies/cookies'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

const Login = () => {
  const navigate = useNavigate()
  const [error, setError] = useState('')

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const { data } = await axiosAuthInstance.post('/auth/register', values)
      setToken(data?.token)
      resetForm()
      navigate('/')
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setError(error.response.data.message)
      } else {
        setError('An unexpected error occurred. Please try again.')
      }
    }
  }

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .required('Password is required'),
    confirm_password: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is required'),
  })

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      confirm_password: '',
    },
    validationSchema,
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
  })

  return (
    <div className='flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        <h2 className='mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900'>
          Signup
        </h2>
      </div>

      <FormikProvider value={formik}>
        <form
          className='mt-10 sm:mx-auto sm:w-full sm:max-w-sm'
          onSubmit={formik.handleSubmit}
        >
          <div className='mb-4'>
            <Field
              name='email'
              type='email'
              label='Email'
              placeholder='Email'
              component={Input}
            />
          </div>

          <div className='mb-4'>
            <Field
              name='password'
              type='password'
              label='Password'
              placeholder='Password'
              component={Input}
            />
          </div>
          <div className='mb-8'>
            <Field
              name='confirm_password'
              type='password'
              label='Password'
              placeholder='Confirm Password'
              component={Input}
            />
          </div>

          {error && (
            <div className='text-red-700 text-sm sm:text-base my-4 font-normal'>
              {error}
            </div>
          )}

          <div className='mt-4'>
            <button
              type='submit'
              label='Sign up'
              disabled={formik.isSubmitting}
              className='flex w-full justify-center rounded-md text-lg font-semibold text-white bg-prime shadow-sm  px-4 py-3 mt-8'
            >
              Sign up
            </button>
          </div>

          <p className='mt-10 text-center text-sm text-gray-500'>
            Have a member?&nbsp;
            <NavLink
              to='/login'
              className='font-semibold leading-6 text-[#EF4044] hover:text-[#EF4044]'
            >
              Signin
            </NavLink>
          </p>
        </form>
      </FormikProvider>
    </div>
  )
}

export default Login
